module.exports = __webpack_public_path__ + "media/images/application/icons/icon-circle-right-orange-775baa8e78490d52c7140bd335b544a9.svg";